import React from 'react'
import CounterModerm from './CounterModerm'

const Footer = () => {
  return (

    <footer>
        <CounterModerm/>
    </footer>
  ) 
}

export default Footer